<template>
  <fragment>
    <md-table-row class="fixed-headers computed-table-header room_target_types">
      <slot name="headers"></slot>
    </md-table-row>
  </fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
export default {
  name: "TargetTableDataHeader",
  components: { Fragment }
};
</script>

<style scoped>
.md-table-head .d-flex .label {
  margin-right: 15px;
}
</style>
<style>
.computed-table-header .md-table-head {
  box-sizing: content-box;
}
</style>
